// extracted by mini-css-extract-plugin
export default {"btn":"j7I7JcEryw_j9WGz4PPE"};